/**
 * Picks v2 or v1 of the Card Deck edit page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import AddEditCardDeck   from './AddEditCardDeck';
import AddEditCardDeckV2 from './AddEditCardDeckV2';

export default function AddEditCardDeckSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? AddEditCardDeckV2 : AddEditCardDeck;
  return <Component {...props} />;
}
